import { QESCheckbox } from "@app/shared/qes-standards";
import { useState, memo } from "react";
import { useImportAddSteps, useImportConfig } from "../hooks";
import { AccessPointProcessingGroup, License } from "../models";

function nonMemoImportAddStepsGroup({ group }: { group: AccessPointProcessingGroup }) {
  const { groupSelected, getGroup, getGroupSteps, selectedLicense } = useImportAddSteps();
  const { getConfiguredGroups } = useImportConfig();
  const [showSteps] = useState(true);
  const groupState = getGroup(group);
  const added = getConfiguredGroups().includes(group);

  const steps = getGroupSteps(group).map((step) => {
    const includedInLicense = selectedLicense === License.Any || step.licenseTypes.includes(selectedLicense);
    return (<span key={step.name} style={{ textDecoration: includedInLicense ? "" : "line-through" }} className={added ? "text-gray" : ""}>{step.name}</span>);
  });
  return (
    <div className="d-flex flex-column pt-2">
      <div className="d-flex flex-row align-items-center">
        <QESCheckbox
          label={getGroup(group).name}
          checked={groupState.selected || added}
          onChange={() => groupSelected(group)}
          disabled={added}
          testId={`import-add-step-groups--${group}`}
        />
      </div>
      {showSteps ? steps : null}
    </div>
  );
}

export const ImportAddStepsGroup = memo(nonMemoImportAddStepsGroup);
